import { Guide } from "@common/models";
import { TourState } from "../tour/persistent-storage/tourState";
import { ChecklistScheduleReason, GuideScheduleReason } from "./scheduler";
import { Checklist } from "@common/schemas/checklist";

export type SchedulerEvents = {
  guideScheduled: { guide: Guide; scheduleReason: GuideScheduleReason; tourState?: TourState };
  guidesSynced: { guides: Guide[] };
  userTargeted: { guide: Guide };
  checklistScheduled: { checklist: Checklist; scheduleReason: ChecklistScheduleReason };
};

export const SchedulerNamespace = "scheduler" as const;
